import { render, staticRenderFns } from "./ItemPreview.vue?vue&type=template&id=b8f4c0ba"
import script from "./ItemPreview.vue?vue&type=script&lang=js"
export * from "./ItemPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports